import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const holding = async (): Promise<any> => {
  const holding = useJSONStore.getState().holdingType;
  const token = useUserStore.getState().userToken;
  const setHolding = useJSONStore.getState().setHolding;

  if (holding.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.holding}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setHolding(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default holding;
